<script>
  export let display = false;
  export let fullHeight = false;
  export let home = false;
  export let lang = undefined;

  function refresh () {
    window.location.reload();
  }

  const i18n = {
    somethingWentWrong: {
      cs: 'Něco se pokazilo,',
      en: 'Something went wrong,',
    },
    tryAgainLater: {
      cs: 'zkuste to prosím později.',
      en: 'please try again later.',
    },
    refreshPage: {
      cs: 'Obnovit stránku',
      en: 'Refresh page',
    },
  };
</script>

{#if display}
  <div class='error' class:error-full-height={fullHeight} class:error-home={home}>
    <div class='error-text'>
      <div class='error-text-something-went-wrong'> {i18n.somethingWentWrong[lang]} </div>
      <div class='error-text-try-again-later'> {i18n.tryAgainLater[lang]} </div>
    </div>

    <div class='error-refresh' on:click={refresh}> {i18n.refreshPage[lang]} </div>
  </div>
{/if}

<style>
  .error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
    min-height: max(calc(30vh - 80px), 70px);

    z-index: 3;
  }

  .error-full-height {
    height: max(calc(100vh - 60px), 70px);
  }

  .error-home {
    min-height: max(calc(30vh - 160px), 70px);
  }

  .error-text {
    display: flex;
    gap: 0.25em;
  }

  .error-text-something-went-wrong, .error-text-try-again-later {
    display: flex;
    align-items: center;

    height: 22.5px;

    text-align: center;
    text-transform: uppercase;

    letter-spacing: 1.2px;
  }

  .error-refresh {
    display: flex;
    align-items: center;

    height: 22.5px;

    text-align: center;
    text-transform: uppercase;
    text-decoration: underline;
    text-decoration-thickness: 1.5px;
    text-decoration-color: transparent;

    font-weight: bold;

    letter-spacing: 1.2px;

    color: var(--primary);

    cursor: pointer;

    transition: text-decoration-color 0.25s ease-in-out;
  }

  .error-refresh:hover {
    text-decoration-color: var(--primary);
  }

  :global(body.dark) .error-refresh {
    color: var(--tertiary-dark);
  }

  :global(body.dark) .error-refresh:hover {
    text-decoration-color: var(--tertiary-dark);
  }

  @media only screen and (max-width: 550px) {
    .error-text {
      flex-direction: column;
      align-items: center;
      gap: 0em;
    }
  }
</style>
